require('./billboard-unit.scss');



//////////////////
// WEBPACK FOOTER
// ./src/interlock/core-page/billboard-unit/billboard-unit.js
// module id = 194
// module chunks = 0 1